/* React hooks */
import {useEffect, useState} from "react";
/* Routing */
import {Link, useParams} from "react-router-dom";
/* Contexts */
import useData from "../../../hooks/useData";
import useAuth from "../../../hooks/useAuth";
import {
    getEstimateLine,
    getEstimateSectionList,
    getEstimateTemplateList
} from "../../../api/admin/estimateReq";
/* Components */
import Header from "../../../components/common/Header";
import Icon from "../../../components/common/Icon";
import DevisList from "../../../components/common/admin/DevisList";
import FormEstimation from "../../../forms/admin/FormEstimation";
import Dashboard from "../../../components/common/dashboard/Dashboard";
import {estimateLineOrder} from "../../../helper/orders";
import usePager from "../../../hooks/usePager";


export default function ViewEstimateTemplate() {
    const {id} = useParams();
    const {
        estimateDetails, setEstimateDetails,
        estimateSectionList, setEstimateSectionList,
        estimateSelectedSection,
        formId, setFormId,
        setEstimateLine
    } = useData();
    const { currentPage, setCurrentPage, itemsPerPage, setTotalPages } = usePager();
    const [totalItems, setTotalItems] = useState();
    const {auth} = useAuth();
    const token = auth.token;
    const tab = "devis";
    const tabSource = "fa fa-bars";
    const source = "fa fa-file-invoice-dollar";
    const [ showCreateModal, setShowCreateModal ] = useState(false);
    const [ showUpdateModal, setShowUpdateModal ] = useState(false);

    const currentSection = estimateSectionList?.find(sec => sec.section === id);

    const apiEstimateSectionList = async () => {
        const response = await getEstimateSectionList(token)
        setEstimateSectionList(response)
    }

    const apiEstimateTemplateList = async () => {
        const response = await getEstimateTemplateList(id, token, currentPage, itemsPerPage)
        setEstimateDetails(response?.estimateTemplateList)
        setTotalItems(response?.totalItems)
    };

    const apiEstimateLine = async () => {
        const response = await getEstimateLine(token, formId)
        setEstimateLine(response)
    };

    useEffect(() => {
        setCurrentPage(1)
        setTotalPages(Math.ceil(totalItems / itemsPerPage))
    }, [ totalItems, itemsPerPage ]);

    useEffect(() => {
        apiEstimateTemplateList();
    }, [ id, currentPage, itemsPerPage ]);

    useEffect(() => {
        apiEstimateSectionList()
        setFormId("0")
    }, []);

    useEffect(() => {
        apiEstimateLine()
    }, [formId]);

    const handleAddEstimateLine = (e) => {
        e.preventDefault();
        setFormId("0");
        setShowCreateModal(true)
    }
    useEffect(() => {
        let targets = document.getElementsByClassName("edit-estimate-line");
        for (let target of targets) {
            target.addEventListener("click", handleEditEstimateLine)
        }
    }, [ apiEstimateSectionList ]);

    const handleEditEstimateLine = (e) => {
        setFormId(e.currentTarget.getAttribute("id"));
        setShowUpdateModal(true)
    }

    let editButtonList = document.querySelectorAll(".fa-pen-to-square.template-line");
    editButtonList.forEach((button) => {
        button.onclick = handleEditEstimateLine
    })

    return (
        <main className="admin">
            <Header
                parent="Administration"
                location="Devis"
                slug={`/admin/accueil`}
            />
            <div>
                { (showUpdateModal || showCreateModal) &&
                    <div id={formId} className="modal estimation">
                        <FormEstimation apiEstimateLine={apiEstimateLine} apiEstimateTemplateList={apiEstimateTemplateList} legend="Modification d'un devis" setShowUpdateModal={setShowUpdateModal} setShowCreateModal={setShowCreateModal} section={estimateSelectedSection}/>
                    </div>
                }
                <nav className="tabs-menu">
                    <ul>
                        <li><Link to="/admin/documents">Voir les documents</Link></li>
                        <li><Link to="/admin/documents/courriers">Gérer les courriers</Link></li>
                        <li className="active"><Link to="/admin/documents/devis/section/1/voir">Voir les devis type</Link></li>
                        <li><Link to="/admin/documents/devis/categories">Gérer les catégories</Link></li>
                    </ul>
                </nav>
                <div className="content-container">
                    <Icon source="fa fa-file-invoice-dollar" span="Liste des devis types"/>
                    <DevisList/>
                    <div className="dashboard estimate">
                        {tab === "devis" &&
                            <>

                                {!currentSection &&
                                    <p>Veuillez sélectionner une section valide.</p>
                                }
                                {currentSection &&
                                    <>
                                        <div className="flex">
                                            <span>{currentSection.section}</span> <p className="description">{currentSection.description}</p>
                                            <div className="flex-buttons">
                                                <button className="green-button" onClick={handleAddEstimateLine}>
                                                    <i className="fa fa-plus"/><span>Ajouter une ligne</span>
                                                </button>
                                            </div>
                                        </div>
                                        <Dashboard apiEstimateTemplateList={apiEstimateTemplateList} location="Devis"
                                                   dataObject={estimateDetails || []}
                                                   order={estimateLineOrder}/>
                                    </>
                                }
                            </>
                        }
                    </div>
                </div>
            </div>
        </main>

    )
}